import { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton } from '@chakra-ui/react';
export const CUIDrawer = Drawer;
export const CUIDrawerBody = DrawerBody;
export const CUIDrawerFooter = DrawerFooter;
export const CUIDrawerHeader = DrawerHeader;
export const CUIDrawerOverlay = DrawerOverlay;
export const CUIDrawerCloseButton = DrawerCloseButton;
export const CUIDrawerContent = DrawerContent;